import { PropsWithChildren } from 'react';
import { Avatar, FormItemProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { StyledInfoCard } from './styles';

type ValidateStatus = FormItemProps['validateStatus'];

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  disabled?: boolean;
  onEdit?: () => void;
  validateStatus?: ValidateStatus;
  help?: string;
}

const InfoCard = ({ icon, title, children, disabled, onEdit, validateStatus, help }: PropsWithChildren<InfoCardProps>) => {
  const { t } = useTranslation();
  const hasError = validateStatus === 'error';

  return (
    <StyledInfoCard $hasError={hasError}>
        <div className="ep-info-card-header">
          <div className="ep-info-card-title-wrapper">
            <Avatar className="ep-icon-avatar" icon={icon} />
            <span className="ep-info-card-title">{t(title)}</span>
          </div>
          <span className={`ep-info-card-edit-button${disabled ? ' ep-info-card-edit-button-disabled' : ''}`} onClick={disabled ? undefined : onEdit}>
            {t('edit')}
          </span>
        </div>
      <div className="ep-info-card-content">
        {children}
        {help && hasError && <span className="ep-info-card-help">{t(help)}</span>}
      </div>
    </StyledInfoCard>
  );
};

export default InfoCard;